import { render } from "./list-client-types.vue?vue&type=template&id=f5886fb8&lang=html"
import script from "./list-client-types.vue?vue&type=script&lang=js"
export * from "./list-client-types.vue?vue&type=script&lang=js"

import "./list-client-types.vue?vue&type=style&index=0&id=f5886fb8&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__